module.exports = __webpack_public_path__ + "static/media/autopilot-active.70a00921.svg";